import store from '@/store/store';
import ApiService from '@/services/api.service';
import i18n from '@/locales/i18n';
import { CONFIG } from '@/app.config';

// import { CONNECT } from '@/app.config';

const SceneService = {
  /**
   * Obtiene el clima de una instalación
   * y los guardo en el store
   *
   * @param {Object} data - Datos de la instalación
   * @returns {Object} - Clima de la instalación
   */
  // eslint-disable-next-line consistent-return
  async getWeather(installationID, installation) {
    if (store.getters['globalModule/isDemo']) return null;
    if (!CONFIG.WEATHER || !installation.lat || !installation.long) return null;

    // Parse data
    const params = {
      lat: installation.lat,
      lang: i18n.locale,
      long: installation.long,
      units: installation.units,
    };

    // Request
    const resource = `weather`;
    const response = await ApiService.get(resource, { params });

    store.dispatch('unitsModule/saveWeather', { installationID, data: response.data });
  },
};

export default SceneService;
